// src/utils/seedData.js
// ─────────────────────────────────────────────────────────────
//  Firestore 샘플 공고 3개 자동 생성 유틸리티
//  사용: 앱 첫 실행 시 자동 호출 또는 개발자가 수동 호출
// ─────────────────────────────────────────────────────────────

import { collection, addDoc, getDocs, query, limit, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

const SAMPLE_JOBS = [
  {
    title: "카페 홀 서빙",
    company: "블루보틀 강남점",
    category: "서비스",
    pay: 12000,
    duration: 4,
    slots: 2,
    filledSlots: 0,
    startDate: new Date(Date.now() + 86400000).toISOString().split("T")[0],
    startTime: "14:00",
    address: "서울 강남구 테헤란로 123",
    location: "강남구",
    lat: 37.4979,
    lng: 127.0276,
    urgent: true,
    detail: "음료 서빙, 테이블 정리, 손님 응대 등 홀 전반 업무를 담당합니다. 경험이 없어도 교육 후 시작 가능합니다. 복장은 단정한 캐주얼로 부탁드립니다.",
    tags: ["서빙", "음료", "단기"],
    employerId: "sample",
    employerName: "블루보틀 강남점",
    status: "open",
    viewCount: 24,
    applyCount: 3,
  },
  {
    title: "행사장 안내 스태프",
    company: "코엑스 이벤트팀",
    category: "행사",
    pay: 13000,
    duration: 6,
    slots: 5,
    filledSlots: 1,
    startDate: new Date(Date.now() + 172800000).toISOString().split("T")[0],
    startTime: "09:00",
    address: "서울 강남구 영동대로 513 코엑스",
    location: "삼성동",
    lat: 37.5115,
    lng: 127.0595,
    urgent: false,
    detail: "전시회 입장 안내, 좌석 배정, 안내 데스크 업무를 담당합니다. 밝은 미소와 친절한 태도를 갖춘 분을 환영합니다. 유니폼 지급 예정입니다.",
    tags: ["행사", "안내", "유니폼"],
    employerId: "sample",
    employerName: "코엑스 이벤트팀",
    status: "open",
    viewCount: 41,
    applyCount: 8,
  },
  {
    title: "물류센터 분류 작업",
    company: "쿠팡 송파 물류센터",
    category: "물류",
    pay: 14000,
    duration: 8,
    slots: 10,
    filledSlots: 2,
    startDate: new Date(Date.now() + 86400000).toISOString().split("T")[0],
    startTime: "06:00",
    address: "서울 송파구 장지동 850",
    location: "송파구",
    lat: 37.4744,
    lng: 127.1236,
    urgent: true,
    detail: "택배 물품 분류 및 포장 작업입니다. 서있는 작업이 많으므로 편한 복장과 운동화 착용을 권장합니다. 조기 퇴근 시 해당 시간만큼 시급 지급합니다.",
    tags: ["물류", "분류", "야간"],
    employerId: "sample",
    employerName: "쿠팡 송파 물류센터",
    status: "open",
    viewCount: 67,
    applyCount: 15,
  },
];

export async function seedSampleJobs() {
  try {
    // 이미 공고가 있으면 시드 스킵
    const snap = await getDocs(query(collection(db, "jobs"), limit(1)));
    if (!snap.empty) return;

    for (const job of SAMPLE_JOBS) {
      await addDoc(collection(db, "jobs"), {
        ...job,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    }
    console.log("[Seed] 샘플 공고 3개 생성 완료");
  } catch (e) {
    console.warn("[Seed] 샘플 데이터 생성 실패:", e.message);
  }
}
